import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class StatistiquesService {

  constructor(private http:HttpClient) { }

  httpOptions = {
    headers: new HttpHeaders({
      "accept": "application/json;odata=Nometadata",
      "content-type": "application/json;odata=verbose"
    })
  };
 // ANP Code Begin
 getStatistiqueAnnuelNational(Url){
  return this.http.get(Url+"/_api/web/lists/GetByTitle('StatistiquesNationales')/items?"
  +"$select=*,File/ServerRelativeUrl&$expand=File&$filter=ContentType eq 'Statistique annuel national'",this.httpOptions);
}
getStatistiqueTrimNational(Url){
  return this.http.get(Url+"/_api/web/lists/GetByTitle('StatistiquesNationales')/items?"
  +"$select=*,File/ServerRelativeUrl&$expand=File&$filter=ContentType eq 'Statistique Trim national'",this.httpOptions);
}
 //ANP Code end
  getStatistiqueAnnuel(Url){
    return this.http.get(Url+"/_api/web/lists/GetByTitle('Statistiques')/items?"
    +"$select=*,File/ServerRelativeUrl&$expand=File&$filter=ContentType eq 'Statistique Annuelle'",this.httpOptions);
  }
  getRapportDeSynthese(Url){
    return this.http.get(Url+"/_api/web/lists/GetByTitle('Statistiques')/items?"
    +"$select=*,File/ServerRelativeUrl&$expand=File&$filter=ContentType eq 'Rapport De Synthèse'",this.httpOptions);
  }  	
  getStatistiqueMensuelle(Url){
    return this.http.get(Url+"/_api/web/lists/GetByTitle('Statistiques')/items?"
    +"$select=*,File/ServerRelativeUrl&$orderby=Annee desc&$expand=File&$filter=ContentType eq 'Statistique Mensuelle'",this.httpOptions);
  }

  getStatistiqueAnnuelLastOne(Url){
    return this.http.get(Url+"/_api/web/lists/GetByTitle('Statistiques')/items?"
    +"$select=*,File/ServerRelativeUrl&$expand=File&$orderby=Annee desc&$top=1&$filter=ContentType eq 'Statistique Annuelle'",this.httpOptions);
  }
  getRapportDeSyntheseLastOne(Url){
    return this.http.get(Url+"/_api/web/lists/GetByTitle('Statistiques')/items?"
    +"$select=*,File/ServerRelativeUrl&$expand=File&$orderby=Annee desc&$top=1&$filter=ContentType eq 'Rapport De Synthèse'",this.httpOptions);
  }  	
  getStatistiqueMensuelleLastOne(Url){
    return this.http.get(Url+"/_api/web/lists/GetByTitle('Statistiques')/items?"
    +"$select=*,File/ServerRelativeUrl&$expand=File&$orderby=Created desc&$filter=ContentType eq 'Statistique Mensuelle'",this.httpOptions);
  }
}
